var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60866 11.6666C5.722 12.2377 7.00271 12.3924 8.22001 12.1028C9.43731 11.8132 10.5111 11.0983 11.248 10.0871C11.9849 9.07575 12.3363 7.83453 12.239 6.58704C12.1417 5.33955 11.602 4.16784 10.7172 3.28306C9.83243 2.39827 8.66072 1.85859 7.41323 1.76127C6.16574 1.66395 4.92452 2.01539 3.91322 2.75226C2.90192 3.48912 2.18706 4.56296 1.89746 5.78026C1.60785 6.99756 1.76254 8.27828 2.33366 9.39161L1.16699 12.8333L4.60866 11.6666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.4d0c5cfc7e8ca5eea5bd469aee862aca.svg";
export { ForwardRef as ReactComponent };